<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">Dashboard</router-link>
            <router-link to="/school/examination-and-assessment" class="text-white">
                <i class="fa fa-ellipsis-v mx-2"></i>Examination and Assessment Management
            </router-link>
            <span class="text-white form-inline"><i class="fa fa-ellipsis-v mx-2"></i>Mock Record</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">

            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card">
                        <div class=" card-header">
                            <h2 class="card-title">Mock Record</h2>
                        </div>
                        <div class="card-body">
                            <div class="form-inline text-center">
                                <select v-model="MockIdval" class="form-control ml-3" @change="getoption()"
                                    :disabled="mocks === null">
                                    <option value="0">{{ mocks === null ? '⏳ Loading...' : '- Select Mock -' }}</option>
                                    <option v-for="item in mocks" :key="item.Id" v-bind:value="item.Id">
                                        {{ item.ExamTitle }} ({{ item.Sch_Class }})
                                    </option>
                                </select>

                                <select v-model="SessionIdval" class="form-control ml-3" :disabled="Sessionitems === null">
                                    <option value="0">{{ Sessionitems === null ? '⏳ Loading...' : '- Select Session -'
                                    }}</option>
                                    <option v-for="item in Sessionitems" :key="item.Id" v-bind:value="item.Id">
                                        {{ item.SchSession }}
                                    </option>
                                </select>
                                <select v-model="OptionIdval" class="form-control ml-3" @change="getmocksubject()"
                                    :disabled="optionitems === null">
                                    <option value="0">{{ optionitems === null ? '⏳ Loading...' : '- Select Option -' }}
                                    </option>
                                    <option v-for="item in optionitems" :key="item.Id" v-bind:value="item.Id">
                                        {{ item.ClassOption }}
                                    </option>
                                </select>
                                <select v-model="SubjectIdval" class="form-control ml-3"
                                    @change="GetStudentForMockRecord()" :disabled="subjectitems === null">
                                    <option value="0">{{ subjectitems === null ? '⏳ Loading...' : '- Select Subject -'
                                    }}
                                    </option>
                                    <option v-for="item in subjectitems" :key="item.Id" v-bind:value="item.SubjectId">
                                        {{ item.SubjectName }}
                                    </option>
                                </select>
                            </div>
                            <div class="table-responsive mt-2">
                                <table class="table table-borderless table-striped table-hover table-sm">
                                    <thead>
                                        <tr>
                                            <th>Admission Number</th>
                                            <th>Student Name</th>
                                            <th>Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="student in mockrecorditem" :key="student.studentId">
                                            <td class="align-middle" data-label="Admission Number">{{ student.admNo }}
                                            </td>
                                            <td class="align-middle" data-label="Student Name">{{ student.studentName }}
                                            </td>
                                            <td class="align-middle" data-label="Score">
                                                <input type="number" class="form-control" v-model.number="student.score"
                                                    :max="100" @change="validateScore(student)" />
                                            </td>                                                                                     
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="text-center mb-3" v-if="mockrecorditem">
                                <button type="submit" class="btn btn-primary my-4"
                                    @click.prevent="submitdata">Submit</button>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner"
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin"
export default {
    name: 'MockRecord',
    mixins: [Alert, CheckStaffUser],
    components: {
        PageSpinner
    },
    data() {
        return {
            accessDetails: null,
            MockIdval: 0,
            SessionIdval: 0,           
            OptionIdval: 0,
            SubjectIdval: 0,           
            Sessionitems: null,
            subjectitems: null,
            optionitems: null,
            studentitems: null,
            mockrecorditem: null,
            mocks: null,
            onloader: 'none'
        }
    },

    methods: {
        validateScore(student) {
            if (student.score > 100) {
                student.score = 100;
                this.ShowAlertWarning('Invalid Input', `Score cannot exceed 100. Value has been reset.`);
            }
        },
        submitdata() {
            const mockRecordList = (this.mockrecorditem || [])
                .filter(student => Number(student.score) > 0)
                .map(student => ({
                    StudentId: student.studentId,
                    Score: student.score
                }));

            if (mockRecordList.length === 0) {
                this.ShowAlertWarning('No records to submit', 'Only students with scores > 0 will be submitted.');
                return;
            }

            let mockId = this.MockIdval;
            let SessionId = this.SessionIdval;
            let subjectId = this.SubjectIdval;
            let userdata = {
                mockId,
                SessionId,
                subjectId,
                mockRecordList
            }
            this.onloader = 'flex'
            this.$store.dispatch('PortalMockRecord/CreateMockRecord', userdata)
                .then((resp) => {
                    if (resp.responseCode !== "00") {
                        this.onloader = 'none'
                        this.ShowAlertError(resp.responseMessage, '');
                        return;
                    }
                    this.onloader = 'none'
                    this.ShowAlertSuccess("Submitted successfully", '');
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getmockrecord() {
            let MockId = this.MockIdval;
            let StudId = 1;
            let SessionId = this.SessionIdval;
            let Score = 1;
            let SubjectId = this.SubjectIdval;
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            this.Scoreval = '';
            let userdata = {
                MockId,
                Score,
                SubjectId,
                StudId,
                SessionId,
                username,
                accesskey
            }
            this.onloader = 'flex'
            this.$store.dispatch('getmockrecord', userdata)
                .then((resp) => {
                    this.mockrecorditem = resp;
                    this.getstudent();
                    this.onloader = 'none'
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getregsession() {
            this.studentitems = null;
            this.Sessionitems = null;
            this.optionitems = null;
            this.subjectitems = null;
            this.mockrecorditem = null;
            this.SessionIdval = 0;
            this.onloader = 'flex'
            this.$store.dispatch('getregsession')
                .then(resp => {
                    this.Sessionitems = resp;
                    this.onloader = 'none';
                })
                .catch(err => {
                    console.log(err);
                    this.onloader = 'none'
                    this.$store.dispatch('logout')
                    this.$router.push('/home')
                })
        },
        getoption() {
            this.onloader = 'flex';
            this.mockrecorditem = null;
            this.subjectitems = null;
            let val = this.MockIdval;
            this.$store.dispatch('getoptionbymock', val)
                .then((resp) => {
                    this.optionitems = resp;
                    this.onloader = 'none';
                    //console.log(resp)
                })
                .catch(err => {
                    this.onloader = 'none';
                    this.ShowAlertError(err.response.data, '');
                })
        },
        getmocksubject() {
            this.mockrecorditem = null;
            this.subjectitems = null;
            let SubjectId = 1;
            let MockId = this.MockIdval;
            let OptionId = this.OptionIdval;
            let processop = 'U';
            let username = this.$store.state.auth.username;
            let accesskey = this.$store.state.auth.accesskey;
            let payload = {
                SubjectId,
                MockId,
                OptionId,
                processop,
                username,
                accesskey
            }
            this.onloader = 'flex';
            this.$store.dispatch('getmocksubject', payload)
                .then((resp) => {
                    this.subjectitems = resp;
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none';
                    this.ShowAlertError(err.response.data, '');
                })
        },

        getmock() {
            this.onloader = 'flex'
            this.$store.dispatch('getmock')
                .then(resp => {
                    this.mocks = resp;
                    this.onloader = 'none';
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        GetStudentForMockRecord() {
            if (this.MockIdval > 0 && this.SessionIdval > 0 && this.SubjectIdval > 0) {
                let MockId = this.MockIdval;
                let SessionId = this.SessionIdval;
                let SubjectId = this.SubjectIdval;
                let userdata = {
                    MockId,
                    SessionId,
                    SubjectId
                }
                this.onloader = 'flex'
                this.$store.dispatch('PortalMockRecord/GetStudentForMockRecord', userdata)
                    .then((resp) => {
                        if (resp.responseCode === "00") {
                            this.mockrecorditem = resp.data;
                        } else {
                            this.mockrecorditem = null;
                        }
                        this.onloader = 'none'
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            }

        },
        frontEndDateFormat(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        backEndDateFormat(date) {
            return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        },

    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        } else {
            this.getmock();
            this.getregsession();
        }

    }
};
</script>

<style scoped>
/* Mobile-friendly table: stack rows as cards below 576px */
@media (max-width: 576px) {
    .table-responsive table thead {
        display: none;
    }

    .table-responsive table,
    .table-responsive table tbody,
    .table-responsive table tr,
    .table-responsive table td {
        display: block;
        width: 100%;
    }

    .table-responsive table tr {
        margin-bottom: 0.75rem;
        border: 1px solid rgba(0, 0, 0, 0.05);
        padding: 0.5rem;
        border-radius: 6px;
        background: #fff;
    }

    .table-responsive table td {
        padding: 0.25rem 0.5rem;
        text-align: right;
        position: relative;
    }

    .table-responsive table td::before {
        content: attr(data-label) ": ";
        float: left;
        font-weight: 600;
        text-transform: none;
        color: #495057;
    }

    .form-control,
    .form-control-sm {
        width: 100%;
    }
}
</style>
